import { baseApi } from "./baseApi";

const SEND_OUT_COLLECTION_BASE_URL = "/sendOutCollection";

export const sendOutCollectionApi = baseApi.injectEndpoints({
    tagTypes: ["SendOutCollection"],

    endpoints: (builder) => ({
        addSendOutCollection: builder.mutation({
            query: (payload) => ({
                url: SEND_OUT_COLLECTION_BASE_URL,
                method: "POST",
                body: payload,
            }),
            invalidatesTags: (_result, _error, { _id }) => [
                { type: "SendOutCollection", id: _id },
                { type: "SendOutCollection", id: "LIST" },
            ],
        }),

        listSendOutCollection: builder.query({
            query: (params) => ({
                url: SEND_OUT_COLLECTION_BASE_URL,
                params,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result.data.map(({ _id }) => ({
                            type: "SendOutCollection",
                            id: _id,
                        })),
                        { type: "SendOutCollection", id: "LIST" },
                    ]
                    : [{ type: "SendOutCollection", id: "LIST" }],
        }),

        getDDLSendOutCollection: builder.query({
            query: (params) => ({
                url: `${SEND_OUT_COLLECTION_BASE_URL}/ddl`,
                params,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result.data.map(({ _id }) => ({
                            type: "SendOutCollection",
                            id: _id,
                        })),
                        { type: "SendOutCollection", id: "DDL" },
                    ]
                    : [{ type: "SendOutCollection", id: "DDL" }],
        }),

        getSendOutCollectionDetail: builder.query({
            query: (id) => `${SEND_OUT_COLLECTION_BASE_URL}/${id}`,
            providesTags: (_result, _error, { _id }) => [
                { type: "SendOutCollection", id: _id },
                { type: "SendOutCollection", id: "LIST" },
            ],
        }),

        updateSendOutCollection: builder.mutation({
            query: ({ _id, ...body }) => ({
                url: `${SEND_OUT_COLLECTION_BASE_URL}/${_id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (_result, _error, { _id: id }) => [
                { type: "SendOutCollection", id },
                { type: "SendOutCollection", id: "LIST" },
            ],
        }),

         listShipmentsBySendOutCollectionId: builder.query({
      query: ({ sendOutCollectionId, page, limit }) => ({
        url: `${SEND_OUT_COLLECTION_BASE_URL}/${sendOutCollectionId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "SendOutCollection", id: _id },
        { type: "SendOutCollection", id: "LIST" },
    ],
    }),
    }),
});

export const {
    useAddSendOutCollectionMutation,
    useListSendOutCollectionQuery,
    useLazyListSendOutCollectionQuery,
    useLazyGetDDLSendOutCollectionQuery,
    useGetSendOutCollectionDetailQuery,
    useUpdateSendOutCollectionMutation,

  useLazyListShipmentsBySendOutCollectionIdQuery,
} = sendOutCollectionApi;
